"use client";
import Link from "next/link";
import { EyeIcon } from "@heroicons/react/24/outline";

export default function NewsCardComp({ item }: { item: any }) {
  return (
    <div className="group relative bg-white shadow-sm rounded-xl lg:rounded-2xl hover:shadow-md group">
      <Link href={item.href}>
        <img
          alt={item.title}
          src={item.imageSrc}
          className="aspect-square w-full rounded-t-xl lg:rounded-t-2xl bg-gray-200 object-cover group-hover:opacity-75 lg:aspect-auto lg:h-52"
        />
        <div className="p-4">
          <p className="text-xs text-gray-400 max-h-5 capitalize">
            {item.type}
          </p>
          <h3 className="mt-2 text-sm font-semibold text-dark h-11 max-h-11 overflow-hidden line-clamp-2 break-words group-hover:text-green">
            {item.title}
          </h3>
          <div className="flex justify-between mt-4">
            <p className="text-xs text-dark">{item.date}</p>
            <div className="flex items-center gap-1">
              <EyeIcon className="size-4" />
              <p className="text-xs text-dark">{item.viewer}</p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
